const stockInId = {
	stock_in: {
		title: "Stok Masuk",
		subtitle: "Ringkasan daftar stok masuk",
		empty_stock: {
			title: "Tidak ada data stok masuk",
			description: "Silakan tambahkan data stok masuk baru.",
		},
		table: {
			title: "Data Stok Masuk",
			columns: {
				date: "Tanggal",
				ref_id: "Ref ID",
				store: "Toko",
				notes: "Catatan",
				made_by: "Dibuat oleh",
				status: "Status",
			},
		},
		forms: {
			edit: {
				title: "Edit Stok Masuk",
				info: "Informasi stok masuk",
				fields: {
					ref_id: {
						label: "RefId",
						placeholder: "refId",
					},
					store: {
						label: "Toko",
						placeholder: "Pilih Toko",
					},
					notes: {
						label: "Catatan",
						placeholder: "catatan",
					},
					status: {
						label: "Status",
						placeholder: "Pilih Status",
					},
				},
				options: {
					active: "Aktif",
					inactive: "Tidak Aktif",
				},
			},
			add: {
				button: "Tambah Stock Masuk",
				title: "Tambah Stock Masuk",
				description: "Tambah Stock Masuk",
				fields: {
					store: {
						label: "Toko",
						placeholder: "Toko",
					},
					notes: {
						label: "Catatan",
						placeholder: "Masukkan Catatan",
					},
					date_processing: {
						label: "Tanggal proses",
						placeholder: "11/11/2011",
					},
				product_detail: {
					not_found_product: "Product tidak ditemukan",
					title: "Detail Produk",
					loading: "Memuat produk...",
					product: {
						label: "Produk",
						placeholder: "Produk",
						search_product: "Cari produk...",
					},
						qty: { label: "Qty", placeholder: "0" },
						unit: { label: "Satuan", placeholder: "Pcs" },
						buy_price: {
							label: "Harga Beli Per Unit",
							placeholder: "Rp 20.000,-",
						},
						total_price: "Harga total",
						action: {
							label: "Aksi",
						},
					},
				},
			},
		},
		actions: {
			add_product: "Tambah Produk",
			cancel: "Batal",
			save: "Save",
			saving: "Saving...",
			save_changes: "Simpan Perubahan",
			add_products: {
				already_added: "Produk ini sudah ditambahkan",
			},
		},
		status: {
			processed: "Sudah Di Proses",
			inactive: "Non Aktif",
		},
	},
};

export default stockInId;
